import React from "react";

import { Footer } from "../../components/Footer";
import { HeaderWrapper } from "../../components/Header/HeaderWrapper";
import { SectionDotNav } from "../../components/Header/Sectiondotnav";
import { BusinessHeroSection } from "../../components/Page2/BusinessHeroSection";
import { BusinessProfileSection } from "../../components/Page2/BusinessProfileSection";
import { CommunityRewardsSection } from "../../components/Page2/CommunityRewardsSection";
import { CustomerStatsSection } from "../../components/Page2/CustomerStatsSection";
import { DealIdeasSection } from "../../components/Page2/DealIdeasSection";
import { OurAdvantageSection } from "../../components/Page2/OurAdvantageSection";
import { PremiumPlanSection } from "../../components/Page2/PremiumPlanSection";
import { SeeHowEasyItIsSection } from "../../components/Page2/SeeHowEasyItIsSection";
import { TrustedBrandsSection } from "../../components/Page2/TrustedBrandsSection";
import { WhyCouponsWorkSection } from "../../components/Page2/WhyCouponsWorkSection";
import { PricingPlansSection } from "../../components/Page3/PricingPlansSection";

const Page2: React.FC = () => {
  return (
    <div className="relative w-full bg-transparent overflow-x-hidden min-h-screen">
<img
          src="/images/Webp/HeroSectionBg.webp"
          className="absolute w-auto h-auto object-cover top-50"
          alt=""
        />
      <HeaderWrapper />
      <SectionDotNav />

      <main className="relative z-10 flex flex-col items-center pt-[90px] lg:pt-[100px]">
        
        <div className="absolute inset-0 -z-10" />

        <section id="hero" className="w-full flex justify-center">
          <div className="w-full max-w-[1820px]">
            <BusinessHeroSection />
          </div>
        </section>

        <section id="stats" className="w-full flex justify-center">
          <div className="w-full max-w-[1820px]">
            <CustomerStatsSection />
          </div>
        </section>

        <section id="profile" className="w-full flex justify-center">
          <div className="w-full max-w-[1700px]">
            <BusinessProfileSection />
          </div>
        </section>

        <section id="why-coupons" className="w-full flex justify-center mt-12">
          <div className="w-full max-w-[1700px] px-6">
            <WhyCouponsWorkSection />
          </div>
        </section>

        <section id="brands" className="w-full flex justify-center">
          <div className="w-full max-w-[1700px]">
            <TrustedBrandsSection />
          </div>
        </section>

        <section id="deal-ideas" className="w-full flex justify-center mt-12">
          <div className="w-full max-w-[1820px]">
            <DealIdeasSection />
          </div>
        </section>

        <section id="advantage" className="w-full flex justify-center">
          <div className="w-full max-w-[1700px]">
            <OurAdvantageSection />
          </div>
        </section>

        <section id="community" className="w-full flex justify-center">
          <div className="w-full max-w-[1700px]">
            <CommunityRewardsSection />
          </div>
        </section>

        <section id="plans" className="w-full flex justify-center bg-[#F3F3F3]">
          <PricingPlansSection />
        </section>

      </main>
    </div>
  );
};

export default Page2;